enum ReceptorIrradiatedAtomsFilterTypes {
  Methyl = 'Methyl',
  Aromatic = 'Aromatic',
  ShiftX = 'ShiftX',
  Manual = 'Manual',
}

export default ReceptorIrradiatedAtomsFilterTypes;
